// src/constants/labels.js

export const FIELD_LABELS = {
  locality: 'Населений пункт',
  street: 'Вулиця',
  houseNumber: 'Номер будинку',
  houseLetter: 'Літера',
  houseHull: 'Корпус',
  houseEven: 'Непарні',
  houseOdd: 'Парні',
  district: 'Район',
  adminDistrict: 'Адмін-район',
  microdistrict: 'Мікрорайон',
  garageCooperatives: 'Гаражні кооперативи',
  residentialComplex: 'ЖК',
  residentialComplexCommerce: 'ЖК, ТЦ, ТРЦ, БЦ'
};
